import { Component, OnInit, Input } from '@angular/core';
import { ModalController, NavParams} from '@ionic/angular';
import { NgForm } from '@angular/forms';
import moment from 'src/app/utils/moment';
import { HelperService, OrganizationService } from 'src/app/services';
import { MealPlan, Organization } from 'src/app/models';

@Component({
  selector: 'app-meal-plan-settings',
  templateUrl: './meal-plan-settings.page.html',
  styleUrls: ['./meal-plan-settings.page.scss'],
})
export class MealPlanSettingsPage implements OnInit {

  public action: "add" | "edit";
  public form: any;
  public isFormSubmitted: boolean;
  public mealPlan: Partial<MealPlan>;
  public maxDate = (moment as any)().add(1, "year").endOf("year").toISOString();
  public organization: Organization;
  public dates: {start: Date, end: Date};
  public endPickerStartAt: Date = (moment as any)().startOf("day").toDate();

  @Input() type: "user" | "library";
  @Input() premium = false;
  private defaultEndHour = 0;
  private endDateTouched = false;

  constructor(
    private helperService: HelperService,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private organizationService: OrganizationService
  ) {
    this.action = this.navParams.get("action");
    this.mealPlan = this.navParams.get("mealPlan");
    this.organization = this.organizationService.getAppOrganization();
    this.dates = {
      start: new Date(this.mealPlan.startDate),
      end: this.mealPlan.endDate? new Date(this.mealPlan.endDate) : null
    };

    const orgDefaultStartTime: string | null = this.organization?.getSetting("programs")?.defaultStartTime || null;
    const orgDefaultEndTime: string | null = this.organization?.getSetting("programs")?.defaultEndTime || null;
    this.defaultEndHour = this.parseHour(orgDefaultEndTime);
    this.endDateTouched = !!this.dates.end;
    if (this.action === "add" && orgDefaultStartTime) {
      const [hourStr] = orgDefaultStartTime.split(":");
      const hour = parseInt(hourStr, 10);
      if (!Number.isNaN(hour)) {
        const startMoment = (moment as any)(this.dates.start).hour(hour).minute(0).second(0).millisecond(0);
        this.dates.start = startMoment.toDate();
      }
    }
    if (this.action === "add" && this.dates.end && orgDefaultEndTime) {
      const [hourStr] = orgDefaultEndTime.split(":");
      const hour = parseInt(hourStr, 10);
      if (!Number.isNaN(hour)) {
        this.dates.end = (moment as any)(this.dates.end).hour(hour).minute(0).second(0).millisecond(0).toDate();
      }
    }
    const endStart = this.dates.end ? (moment as any)(this.dates.end) : (moment as any)().startOf("day");
    if (!this.dates.end && orgDefaultEndTime) {
      const [hourStr] = orgDefaultEndTime.split(":");
      const hour = parseInt(hourStr, 10);
      if (!Number.isNaN(hour)) {
        endStart.hour(hour).minute(0).second(0).millisecond(0);
      }
    }
    this.endPickerStartAt = this.dates.end || endStart.toDate();
    if(!this.mealPlan.plans || this.mealPlan.plans.length < 1) {
      this.mealPlan.plans = [{
        caloricAdjustment: 0,
        proteinFactor: 1.3,
        fatsFactor: 0.3,
        proteinPercent: 30,
        fatPercent: 30,
        carbPercent: 40,
        goals: {},
        title: "Menu 1",
        meals: []
      }]
    }
   }

  ngOnInit() {
  }

  endDateChanged(value: Date) {
    this.dates.end = this.normalizeNewEndDate(value);
  }

  doReorder(event) {
    const itemMove = this.mealPlan.plans.splice(event.detail.from, 1)[0];
    this.mealPlan.plans.splice(event.detail.to, 0, itemMove);
    event.detail.complete();
  }

  onSubmit(formData: NgForm) {
    this.isFormSubmitted = true;
    if(!formData.valid) {
      return
    }
    this.mealPlan.startDate = this.dates.start.toISOString();
    this.mealPlan.endDate = this.dates.end? this.dates.end.toISOString() : null;
    this.modalCtrl.dismiss({ 
      status: "submitted",
      data: this.mealPlan
    });
  }

  getCounter(data: string, maxLength: number) {
    return `${data? maxLength - data.length : maxLength} /  ${maxLength}`
  }

  cancel() {
    this.modalCtrl.dismiss({ status: "canceled" });
  }

  private parseHour(timeStr: string | null): number {
    if (!timeStr) {
      return 0;
    }
    const hour = parseInt(timeStr.split(":")[0], 10);
    return Number.isNaN(hour) ? 0 : hour;
  }

  private normalizeNewEndDate(value: Date): Date {
    if (!value) {
      this.endDateTouched = false;
      return null;
    }
    const next = (moment as any)(value);
    if (!this.endDateTouched && next.hour() === (moment as any)().hour()) {
      next.hour(this.defaultEndHour).minute(0).second(0).millisecond(0);
    }
    this.endDateTouched = true;
    return next.toDate();
  }
}
